class AlsoAdd extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("cartDrawerOpen", () => this.rollDown())
  }

  rollDown () {
    const closeTimeout = setTimeout(() => {
      this.close();
      clearTimeout(closeTimeout);
    }, 6000)
  }

  disconnectedCallback() {
    document.removeEventListener("cartDrawerOpen", this.rollDown.bind(this));
  }

  close() {
    const details = this.querySelector('details')
    if (details) details.removeAttribute('open')
  }
}

if (!customElements.get('also-add')) customElements.define('also-add', AlsoAdd);